import React from 'react';
import _ from 'lodash';
import { Card, CardContent, CardHeader } from '@mui/material';
import { useQuery } from 'react-fetching-library';
import { ReceiptForm } from './ReceiptForm';
import { InvoiceForm } from './InvoiceForm';
import { CorrectiveInvoiceForm } from './CorrectiveInvoiceForm';
import { ProformaInvoice } from './ProformaInvoiceForm';
import { InvoiceForReceiptForm } from './InvoiceForReceiptForm';
import { CorrectiveReceiptForm } from './CorrectiveReceiptForm';

import { getInvoiceDataAction } from '../../../../../../../services/request';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%'
};

export const DocumentBase = props => {
  const { closeDialog, type, order, season, module, editData, submitCallback } = props;
  const { loading, payload, error } = useQuery(getInvoiceDataAction(order.id, type.code));
  const [invoiceBaseData, setInvoiceBaseData] = React.useState({});

  React.useEffect(() => {
    if (!loading && !error && _.isEmpty(editData)) {
      setInvoiceBaseData(payload);
    } else if (!loading && !error) {
      setInvoiceBaseData({ invoices: payload.invoices, receipts: payload.receipts });
    }
  }, [loading]);

  return (
    <Card sx={{ ...style }}>
      <CardHeader title={type.name} />
      <CardContent >
        {type.name === 'Paragon'
          ? <ReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} />
          : type.name === 'Faktura'
            ? <InvoiceForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} />
            : type.name === 'Faktura korygująca'
              ? <CorrectiveInvoiceForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} />
              : type.name === 'Faktura proforma'
                ? <ProformaInvoice order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} />
                : type.name === 'Faktura do paragonu'
                  ? <InvoiceForReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} />
                  : type.name === 'Paragon korygujący'
                    ? <CorrectiveReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} />
                    : null}
      </CardContent>
    </Card>
  );
};
